import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { TranslatePipe } from '@ngx-translate/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import TYPES from '../../constants/types';

@Component({
  selector: 'app-install-pwa',
  imports: [
    ButtonComponent,
    TranslatePipe
  ],
  templateUrl: './install-pwa.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './install-pwa.component.scss'
})
export class InstallPwaComponent {

  dialogRef = inject<DialogRef<{}>>(DialogRef<{}>);
  data = inject(DIALOG_DATA);

  BUTTON_TYPES: any;

  constructor(){
    this.BUTTON_TYPES = TYPES.UI.BUTTON;
  }

  action(action: string){
    this.dialogRef.close({action});
  }

}
